'use strict';
import { addBrowserClasses } from './modules/_utils';
// import './modules/_nav';
// import './modules/_resizeTimer';
import { smartBannerInit } from './modules/smartbanner';

smartBannerInit();

document.addEventListener('DOMContentLoaded', function() {

  document.getElementsByClassName('no-js')[0].classList.remove('no-js');

  // Common functions
  addBrowserClasses();
  

});


//  // Get session storage value
//  if (sessionStorage.getItem("referrerSite") === null) {
//   var referrerSite = document.referrer;
//   sessionStorage.setItem("referrerSite", referrerSite);
// }
